import React from 'react'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'
import WhenMultipleDepartmentsAreSelected from 'support/conditionals/WhenMultipleDepartmentsAreSelected'

function GuestCountLineChartTooltipInner (props) {
  if (!props) {
    return null
  }

  const guestCount = !isNaN(parseFloat(props.guestcount)) ? parseFloat(props.guestcount) : 0
  const guestCountLY = !isNaN(parseFloat(props.guestcount_ly)) ? parseFloat(props.guestcount_ly) : 0
  const guestCountProduction = !isNaN(parseFloat(props.guestcount_production)) ? parseFloat(props.guestcount_production) : 0

  return (
    <UI.Card>

      <UI.VerticalList>

        <UI.WithSubtitle subtitle={(
          <UI.Text uppercase size='xs' className='tracking-wider'>
            <Translation name='generic.guest_count' />
          </UI.Text>
                )}
        >
          <UI.Text size='sm'>
            {guestCount.toLocaleString()}
          </UI.Text>
        </UI.WithSubtitle>

        <UI.WithSubtitle subtitle={(
          <UI.Text uppercase size='xs' className='tracking-wider'>
            <Translation name='generic.guest_count' /> (LY)
          </UI.Text>
                )}
        >
          <UI.Text size='sm'>
            {guestCountLY.toLocaleString()}
          </UI.Text>
        </UI.WithSubtitle>
        <WhenMultipleDepartmentsAreSelected>
          <UI.WithSubtitle subtitle={(
            <UI.Text uppercase size='xs' className='tracking-wider'>
              <Translation name='generic.guest_count' /> (1:1)
            </UI.Text>
          )}
          >
            <UI.Text size='sm'>
              {guestCountProduction.toLocaleString()}
            </UI.Text>
          </UI.WithSubtitle>
        </WhenMultipleDepartmentsAreSelected>
      </UI.VerticalList>

    </UI.Card>
  )
}

export default React.memo(GuestCountLineChartTooltipInner)
